import { render, staticRenderFns } from "./sidenav.vue?vue&type=template&id=49019b38&"
import script from "./sidenav.vue?vue&type=script&lang=ts&"
export * from "./sidenav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports